import * as types from "../../ActionType";

const initState = {
    zoneType: [],
    loadingZoneType: true
}

const ZoneTypeReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_ZONE_TYPE:
            return { ...state, loadingZoneType: true }
        case types.GET_ZONES_TYPE:
            return { ...state, zoneType: action.payload, loadingZoneType: false }
        case types.DELETE_ZONE_TYPE:
            return { ...state }
        default:
            return state;
    }
};

export default ZoneTypeReducer;

